import React from "react";

export type DpasDataContextValue = {
    dpasId: string;
    getProjectId: () => Promise<string>;
    setDpasId: (id: string) => void;
};

const defaultValue: DpasDataContextValue = {
    dpasId: "",
    getProjectId: async () => "",
    setDpasId: () => {},
};

export const DpasDataContext = React.createContext<DpasDataContextValue>(defaultValue);

export const useDpasData = () => React.useContext(DpasDataContext);
